
import { createComponent } from "@front/utils/alpine";

export default createComponent(() => ({
    setup() {
        this.initSearch();
        this.initReveal();
    },

    initSearch() {
        const input = document.querySelector('.js-filter-input') as HTMLInputElement;
        const elements = document.querySelectorAll('.js-filter-item a');
        if (!input) return;

        input.addEventListener('keyup', () => {
            if (input.value != '') {
                const items = document.querySelectorAll('.js-filter-item a[data-name^="' + input.value.toUpperCase() + '"]');

                elements.forEach((item) => {
                    (item.parentNode as HTMLElement).classList.add('hidden');
                });

                items.forEach((item) => {
                    (item.parentNode as HTMLElement).classList.remove('hidden');
                });
            } else {
                elements.forEach((item) => {
                    (item.parentNode as HTMLElement).classList.remove('hidden');
                });
            }
        });
    },

    // Repli « voir plus / voir moins » avec effet de slide. Une recherche active
    // déplie tout et masque le bouton pour ne pas tronquer les résultats.
    initReveal() {
        const wrapper = document.querySelector('.js-reveal') as HTMLElement;
        const toggle = document.querySelector('.js-reveal-toggle') as HTMLElement;
        const label = document.querySelector('.js-reveal-label') as HTMLElement;
        const input = document.querySelector('.js-filter-input') as HTMLInputElement;
        if (!wrapper || !toggle || !label) return;

        const more = toggle.dataset.more || 'Voir plus';
        const less = toggle.dataset.less || 'Voir moins';
        let expanded = false;
        let releaseTimer: number | undefined;

        const collapsedHeight = (): number => {
            const isDesktop = window.matchMedia('(min-width: 640px)').matches;
            const attr = isDesktop ? wrapper.dataset.collapsedDesktop : wrapper.dataset.collapsedMobile;
            return parseInt(attr || '', 10) || 320;
        };

        const collapse = () => {
            window.clearTimeout(releaseTimer);
            wrapper.style.maxHeight = collapsedHeight() + 'px';
            wrapper.classList.remove('is-expanded');
            toggle.setAttribute('aria-expanded', 'false');
            label.textContent = more;
            expanded = false;
        };

        const expand = () => {
            wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
            wrapper.classList.add('is-expanded');
            toggle.setAttribute('aria-expanded', 'true');
            label.textContent = less;
            expanded = true;
            // libère la hauteur une fois l'animation finie (reste responsive)
            window.clearTimeout(releaseTimer);
            releaseTimer = window.setTimeout(() => {
                if (expanded) wrapper.style.maxHeight = 'none';
            }, 500);
        };

        const needsToggle = (): boolean => wrapper.scrollHeight > collapsedHeight() + 20;

        const refresh = () => {
            if (needsToggle()) {
                wrapper.classList.remove('is-static');
                toggle.classList.add('is-visible');
                if (!expanded) collapse();
            } else {
                wrapper.classList.add('is-static');
                toggle.classList.remove('is-visible');
                wrapper.style.maxHeight = 'none';
            }
        };

        toggle.addEventListener('click', () => {
            if (expanded) {
                // fige la hauteur courante avant de replier pour pouvoir animer
                wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
                requestAnimationFrame(() => requestAnimationFrame(collapse));
            } else {
                expand();
            }
        });

        if (input) {
            input.addEventListener('input', () => {
                if (input.value.trim() !== '') {
                    wrapper.classList.add('is-static', 'is-expanded');
                    toggle.classList.remove('is-visible');
                    wrapper.style.maxHeight = 'none';
                } else {
                    wrapper.classList.remove('is-static', 'is-expanded');
                    expanded = false;
                    refresh();
                }
            });
        }

        window.addEventListener('resize', () => {
            if (input && input.value.trim() !== '') return;
            expanded = false;
            refresh();
        });

        refresh();
    },
}));
